module.exports = __webpack_public_path__ + "static/media/2.bc8e5476.png";